module.exports = __webpack_public_path__ + "img/CIOTY-final-Logo.d58f5e36.webp";